import React, {PureComponent} from "react"
import styled from "styled-components"

import {StatementItem, Wallet} from "@irati/types"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import rewardLogo from "@irati-web/reward/src/images/reward.png"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import rewardWalletTransactionToString from "@irati-web/wallet/src/utils/rewardWalletTransactionToString"
import Card from "@irati/ui/src/Layout/Card"

import PrimaryDetails from "../../../PrimaryDetails"

const StyledImg = styled.img`
  width: 130px;
`

const StyledCard = styled(Card)`
  margin-bottom: 20px;
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

interface Props extends InjectIntl {
  statementItem: StatementItem
  wallet: Wallet
  className?: string
  isRewardWallet?: boolean
}

class UseCreditToBuyReward extends PureComponent<Props> {
  render() {
    const {statementItem, formatMessage} = this.props
    const {transfer} = statementItem
    const {amount, useCreditToBuyReward, currency} = transfer
    const {rewardOrder} = useCreditToBuyReward

    const primaryDetails = {
      image: rewardOrder.reward.thumbnailImage || perkboxLogo,
      title: <StyledImg src={rewardLogo} alt="" />,
      subTitle: rewardWalletTransactionToString(rewardOrder.recipients.results, formatMessage),
      amount,
      currency,
      status: StatusType.SPENT
    }

    const idNamespace = id("use-credit-to-buy-reward", this.props)

    return (
      <StyledCard medium noBorder>
        <PrimaryDetails id={idNamespace} data={primaryDetails} />
      </StyledCard>
    )
  }
}

export default injectIntl(UseCreditToBuyReward)
